import { createStandardMenuItems, Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { WarehouseLocationListItem } from "@msuite/utils/types";

export function RowActions(_props: CellContext<WarehouseLocationListItem, "actions">) {
	return (
		<RowActionsWrapper to={null}>
			<Menu items={createStandardMenuItems({})}>
				<Menu.Button />
			</Menu>
		</RowActionsWrapper>
	);
}
